import { render, staticRenderFns } from "./organization-unit-tree.vue?vue&type=template&id=406148ba&scoped=true"
import script from "./organization-unit-tree.vue?vue&type=script&lang=js"
export * from "./organization-unit-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406148ba",
  null
  
)

export default component.exports